export const items = [
  {
    id: "1",
    label: "Location Features",
    bulletPointList: true,
    content: [
      {
        title: 'Attractions',
        description: [
          'Health/Beauty Spa',
          'Winery Tours',
          'Museums',
          'Zoo',
          'Theme Parks',
          'Water Parks',
        ]
      },
      {
        title: 'Leisure',
        description: [
          'Bird Watching ',
          'Horseback Riding',
          'Outlet Shopping',
          'Wildlife Viewing',
        ]
      },
      {
        title: 'Sports & Adventure',
        description: [
          'Cycling',
          'Hiking',
          'Mountaineering',
          'Skiing',
          'Water Tubing',
          'Whitewater Rafting',
        ]
      },
    ]
  },
  {
    id: "2",
    label: "Amenities",
    bulletPointList: true,
    content: [
      {
        title: "General",
        description: [
          'Wifi',
          'Fireplaces',
          'Main Living Room Ceiling Fans',
          'A/C',
          'Central Heating ',
          'Linens ',
          'Extra Pillows & Blankets',
          'Hangers',
          'Clothing Storage (Closet or Wardrobe)',
          'Hot Water',
          'Toilet Paper',
          'Towels',
          'Rain Shower',
          'Hair Dryer',
          'Washing Machine',
          'Clothes Dryer',
          ' Iron & Board',
        ]
      },
      {
        title: "Kitchen",
        description: [
          'Microwave',
          'Keurig K-duo Coffee Maker',
          'Kettle',
          'Baking Sheet',
          'Refrigerator',
          'Dishwasher',
          'Toaster',
          'Pots & Pans',
          'Barbecue/ Grill Utensils',
          'Gas Stove',
          'Dishes & Utensils',
          'Paper Towels',
          'Freezer',
          'Kitchen Island',
          'Wine Glass',
          'Oven',
          'Spices/ Pantry Items',
          'Blender',
        ]
      },
      {
        title: "Bathrooms",
        description: [
          '3 Bathrooms',
          'Master - Shower, Toilet, Tub',
          'Main Floor Guest Bathroom - Combination Tub/Shower, Toilet',
          'Lower Level Bathroom - Combination Tub/Shower, Toilet',
        ]
      },
      {
        title: "Seelping Arrangements",
        description: [
          '3 Bedrooms, sleeps 5-10',
          'Master Bedroom - 1 king bed',
          'Main floor Guest Bedroom - 1 King bed',
          'Lower Level Living Room/ Game Room - 1 Sleeper Sofa/Futon ',
          'Lower Level Bedroom - 2 Queen Beds',
        ]
      },
      {
        title: "Entertainment",
        description: [
          'Television ',
          'Smart TV',
          'Games/Board Games',
          'Foosball',
          'Air Hockey',
          'Video Arcade',
        ]
      },
      {
        title: "Outdoor",
        description: [
          'Grill - bring your own charcoal',
          'Deck/Patio',
          'Balcony/Terrace',
          'Outdoor Seating',
          'Hot tub',
          'Free parking',
        ]
      },
      {
        title: "Safety",
        description: [
          'Carbon Monoxide Detector ',
          'Exterior Lighting ',
          'Fire Extinguisher',
          'First Aid Kit',
          'Smoke Detector',
        ]
      },
    ]
  },
  {
    id: "3",
    label: "Important Information",
    bulletPointList: false,
    content: [
      {
        title: "Rental Agreement",
        description:
          'To ensure a smooth and secure stay, we require a signed rental agreement, a valid photo ID, and a $500 security deposit hold (not a charge) on a credit card within 24 hours of booking. The access code to the home will be provided once these steps are completed. By booking, you agree to all house rules in this listing as well as the terms in the rental agreement. It’s a quick and easy process to get you ready for your stay!'
      },
      {
        title: "Security Deposit",
        description:
          'Guest shall deposit $500 as a security deposit for any damages to the Property. Said security deposit shall be returned to Guest within 5 days of departure, less any deductions for damages. Guest understands that any repair or replacement costs shall be deducted from said $500 deposit prior to any insurance claim being filed. Should Guest wish to file a claim with the insurance company for reimbursement of any deduction from the $500 deposit, Guest has the right to do so. Should said damages exceed coverage, Guest hereby assumes all liability for reimbursement to Owner for any damages caused by Guest and Guest’s party within 5 (five) business days of receipt of invoice from Owner.'
      },
      {
        title: "Check In/Out",
        description:
          "Check-in at 4:00 PM. Check-out at 10:00 AM. We do not offer early check-in nor late check-out. We do not allow check-ins nor check-outs on holidays."
      },
      {
        title: "Age Requirement",
        description:
          "The primary guest (booker) must be 25 years or older and must be present during the stay. Children are welcome when accompanied by their parent(s) or legal guardian(s)."
      },
      {
        title: "Occupancy",
        description:
          "10 Person Maximum. If you bring more people than accounted for on your reservation, we will charge you $100 per person over said number. Exceeding the maximum permitted occupancy can result in many issues, including a fine by local authorities for not adhering to sprinklers/fire safety, running out of well water, and overflowing the septic tank."
      },
      {
        title: "Accessibility",
        description:
          "Property is NOT wheelchair accessible. The property is 2 stories and stairs are needed to go up or downstairs. A few stairs lead from the driveway to the front door."
      },
      {
        title: "Security Camera",
        description:
          "There are two security cameras, one on the front porch and one at the right deck facing the driveway, in place for your protection. The cameras only turn on and record with motion. If you touch or tamper with the cameras, you will be asked to leave the property immediately."
      },
      {
        title: "Smoking",
        description:
          "This is a NON-SMOKING/VAPING cabin."
      },
      {
        title: "Hot Tub",
        description:
          'The hot tub is for guests 25 and over only. Alcohol and glassware are NOT allowed near the hot tub. There are plastic cups available in the kitchen for use near the hot tub for non-alcoholic drinks. You are not allowed to use the hot tub if you have consumed alcohol or if you are pregnant. Do not dive headfirst into the hot tub. Use the hot tub AT YOUR OWN RISK! Please refer to the hot tub rules posted in the patio for further details.'
      },
      {
        title: "Well Water",
        description:
          'Water supply is solely from a private well. It is safe to drink but we suggest bringing bottled water. Although we have a large storage water tank installed, please be aware that during certain nonspecific times of the year, the well can yield less water than normal. Please practice water conservation to avoid loss of water. Timing of water usage is essential because high usage will deplete the well before it can replenish. The washing machine and the hot tub are the most detrimental to the well supply and use of these items should only take place during times when water use throughout the rest of the cabin is minimal. After use of these items, the well will need to be replenished so please allow adequate time before additional heavy water use.'
      },
      {
        title: "Outdoor Grill",
        description:
          "A large charcoal grill is provided for your use, please do not move the grill for safety reasons. Bring your own charcoal. Ash can go in the attachment below the grill. A chimney starter is provided under the kitchen sink, please make sure you know how to use one (can find information videos on YouTube for instructions on how to use this instead of lighter fluid) and be sure to return it to its proper location after use (to prevent rust)."
      },
      {
        title: "Trash",
        description:
          'Please dump liquids into the sink and not into trash bags. Place all trash into trash bags and secure trash bags in the bear proof trash containers next to the driveway. We do not have regularly scheduled trash pick-ups. If needed, there are trash drop-off convenience centers, the closest location is at 943 Center View Rd, Sevierville, TN 37862.'
      },
      {
        title: "Garbage Disposal",
        description:
          "Please do not throw fibrous foods (ie. banana skins, broccoli, celery, corn husks, potato peels), bones, eggshells, nor coffee grounds into the garbage disposal. This will clog the blades and you will end up with an overflowing sink, which is no fun for anyone. Also, please don't stick body parts into the garbage disposal. Losing a finger is not going to be a pleasant vacation memory."
      },
      {
        title: "Curtains",
        description: "Most of the rooms have curtains. The master bedroom currently does not have window treatments covering the floor-to-ceiling windows , please bring eye masks if light is bothersome in the morning."
      },
      {
        title: "Fireplace",
        description: "There are two gas fireplaces which are only turned on from October 1 - April 1. No outdoor fires are allowed except for the charcoal BBQ grill. No unauthorized fires (including candles)."
      },
      {
        title: "Weather",
        description:
          "No refunds for weather/ natural disasters/ power outages/ other events that are beyond our control. Please purchase travel insurance for coverage."
      },
      {
        title: "Pets",
        description:
          "We’re happy to welcome up to 2 dogs per stay (with owner’s approval, $200 per pet). We kindly request that pets remain off all furniture and beds during your stay. To help us maintain the quality of our cabin, an additional $500 fine will be charged if evidence of pets being on furniture or bedding is found."
      },
      {
        title: "Critters",
        description:
          "We subscribe to monthly pest control, however this cabin is in the wilderness, and with that comes bugs and other wild animals, including bears and snakes. Please practice bear safety (guidelines will be posted on the refrigerator). Remember to keep your doors locked, throw trash in the bear-proof containers, don't feed or try to approach a bear, and don't leave any food outdoors, including on the grill nor in your car."
      },
      {
        title: "Roof",
        description:
          "The roof is metal with no attic. If a squirrel crawls on the roof or if it is raining, you will hear it, no need to be alarmed."
      },
      {
        title: "Kitchen/Bathroom Items",
        description:
          "We provide a starter pack of items consisting of dishwasher tablets, paper towels, toilet paper, trash bags, kitchen sponge, and K-cup pods. Toiletries (including shampoo), condiments, ground coffee, creamer, sugar, zip lock bags, and charcoal are NOT provided."
      },
      {
        title: "Additional Safety",
        description:
          "Do not lean or hang on the railings."
      }
    ]
  }
]
